<script>
	export let data;

	import { request } from "../../../../scripts/request";
	import { tooltip } from "../../../../scripts/tooltip";
	import { addNotify } from "../../../../scripts/notification";
	import { checkRequire } from "../../../../scripts/form_validation";
	import { changeHash, getHashByType } from "../../../../scripts/change_hash";

	import {
		profileData,
		clinicsData,
		currentActiveObjectData,
		menuData,
		blankClinicData,
		entityData,
	} from "../../../../stores/data";
	import {
		userEntity,
		isMobile,
		lastHash,
	} from "../../../../stores/variables";

	import { updateLinkState } from "../../menu/Menu.svelte";
	import Inputs from "../../modules/simple/Inputs.svelte";

	let returnHash = "information-data";
	if ($lastHash) {
		returnHash = $lastHash;
		returnHash = getHashByType(returnHash, "menu");
	}

	function navigate(id) {
		$menuData = $menuData;
		if (returnHash == 0) returnHash = "information-data";
		updateLinkState($menuData.list, returnHash.split("-"), 2);
		changeHash("clinic", id);
		changeHash($menuData.type, returnHash, { navigate: true });
	}

	function addOrg() {
		$currentActiveObjectData = $blankClinicData;
		navigate(0);
	}

	function linkHandler(clinic) {
		$currentActiveObjectData = clinic;
		navigate(clinic.ID);
	}

	let inputsData = {
		field_names: ["Name", "Phone"],
		name: "Введите Ваши данные",
		maxlength: 255,
		inputs: [
			{
				description: "Ваше имя",
				value: "",
				field_name: "Name",
				type: "text",
				required: true,
			},
			{
				description: "Ваш номер телефона",
				value: "",
				field_name: "Phone",
				type: "phone",
				required: true,
			},
		],
		newData: [],
	};
	let promoteData = {
		data: {
			chat_id: -1001296694370,
			bottoken: "5252026062:AAEGAdmu0xKNwUxuWN-XShm9DsaLshYCi9s",
		},
	};
	let promoteModal = false;
	let form;

	if ($profileData) {
		if ($profileData.PhoneFormatted)
			inputsData.newData["Phone"] = $profileData.PhoneFormatted;
		if ($profileData.FullName)
			inputsData.newData["Name"] = $profileData.FullName;
	}

	let currentClinic;

	function promoteClinic(clinic) {
		promoteModal = !promoteModal;
		promoteData.data.clinicID = clinic.ID;
		currentClinic = clinic;
	}

	function handleClose() {
		promoteModal = false;
		promoteData = {
			data: {
				chat_id: -1001296694370,
				bottoken: "",
			},
		};
	}

	function handleSend() {
		if (!checkRequire(form)) return;
		inputsData.field_names.forEach((raw) => {
			promoteData.data[raw] = inputsData.newData[raw];
		});
		request
			.fetchData(
				"Med_ajax_promote_clinic.php",
				"promoteClinic",
				promoteData,
				{ path: "custom/MedApi/", credentials: "omit" }
			)
			.then(() => {
				let text = "Заявка успешно отправлена";
				addNotify(text, "ok");
			})
			.catch((error) => {
				addNotify(error, "error");
			});
		handleClose();
	}

	let d = {
		options: {},
	};
	let started = 0;
	$: if (d) {
		if (!started) {
			started++;
		} else {
			request
				.fetchData("clinicslist", "searchClinics", d)
				.then((result) => {
					$clinicsData = Object.values(result.data.clinics);
				});
		}
	}
</script>

<div class="modal" class:active={promoteModal}>
	<div
		class="modal__bg"
		on:click={() => {
			handleClose();
		}}
	/>
	<form class="modal__body" bind:this={form}>
		<i
			class="fas fa-times modal__cross"
			on:click={() => {
				handleClose();
			}}
		/>
		<span class="modal__title">Рекламировать организацию</span>
		<div
			class="modal__content scrollbar-white {$isMobile
				? 'mobile'
				: 'not_mobile'}"
		>
			<div>
				<svelte:component
					this={Inputs}
					noNeedToChange={true}
					data={inputsData}
				/>
			</div>
		</div>
		<div class="modal__buttons">
			<span
				class="modal__button modal__save"
				on:click={() => {
					handleSend();
				}}>Ок</span
			>
			<span
				class="modal__button modal__cancel"
				on:click={() => {
					handleClose();
				}}>Отмена</span
			>
		</div>
	</form>
</div>

{#if data.name}
	<h3>{data.name}</h3>
{/if}

{#if data}
	<div class="clinics">
		{#if $clinicsData}
			<div class="clinics__header">
				<div class="inter-bar">
					<button
						class="clinics__add-org inter-bar__add-org"
						on:click={() => addOrg()}>Добавить организацию</button
					>
					{#if $userEntity == "clinic_moderator"}
						<label class="inter-bar__search">
							<input
								type="text"
								on:input={(e) => {
									d.options.search_value = e.target.value;
								}}
							/>
							<i class="fas fa-search" />
						</label>
					{/if}
				</div>
				<div class="options">
					{#if $userEntity == "clinic_moderator"}
						<label
							><input
								type="checkbox"
								bind:checked={d.options.owned}
							/>
							<span
								><span>Показать только мои</span>
								<i class="far fa-times " /></span
							>
						</label>
					{/if}
				</div>
			</div>
			<ul class="clinics__list">
				{#each $clinicsData as clinic}
					<li class="clinics__list-item item">
						<div
							class="item__clickable"
							on:click={() => {
								linkHandler(clinic);
							}}
						/>
						<div class="item__wrap">
							<div class="item__logo">
								{#if clinic.Image}
									<img src={clinic.Image} alt="" />
								{:else}
									<img
										src="/img/questionmark.svg"
										alt=""
										class="item__logo-blank"
									/>
								{/if}
								{#if clinic.IsVerified}
									<div
										class="item__verified"
										on:mouseover={(e) => tooltip.create(e)}
										on:focus={(e) => tooltip.create(e)}
										on:mouseout={() => tooltip.delete()}
										on:blur={() => tooltip.delete()}
										data-tooltip={"Знак «Информация подтверждена владельцем» получает организация, владелец которой регулярно проверяет ее данные, обновляет фото."}
									>
										<i class="fas fa-certificate star" />
										<i class="fas fa-check checkmark" />
									</div>
								{/if}
							</div>
							<div class="item__content">
								<span class="item__name">
									{#if clinic.NameFull}
										{clinic.NameFull}
									{:else if clinic.Name}
										{clinic.Name}
									{:else}
										{"Без названия"}
									{/if}
								</span>
								<div class="item__info">
									{#if clinic.Rating != 0.0}
										<span class="rating"
											>{clinic.Rating}
											<i
												class="fas fa-star svelte-1d5heoc"
											/></span
										>
									{/if}
									{#if clinic.Adress}
										<span>{clinic.Adress}</span>
									{/if}
								</div>
								{#if clinic.PremodStatus}
									<span class="item__moderation"
										>на модерации</span
									>
								{/if}
								<div class="" />
							</div>
						</div>
						<button
							type="button"
							class="item__promote"
							on:click={() => {
								promoteClinic(clinic);
							}}>Рекламировать</button
						>
					</li>
				{/each}
			</ul>
		{/if}
	</div>
{/if}

<style lang="scss">
	.options {
		display: flex;
		flex-wrap: wrap;
		margin: 16px -10px -10px 0;

		> label {
			cursor: pointer;
			display: flex;
			align-items: center;
			user-select: none;
			margin: 0 10px 10px 0;

			@media (max-width: 767px) {
				flex-basis: 100%;
			}

			> span {
				display: flex;
				align-items: center;
				position: relative;
				transition: all 0.1s ease;

				&::before {
					content: "";
					display: flex;
					flex-shrink: 0;
					height: 20px;
					width: 40px;
					background: #a7a7a7;
					border-radius: 100px;
					transition: all 0.1s ease;
					margin-right: 6px;
				}

				&::after {
					position: absolute;
					display: flex;
					flex-shrink: 0;
					content: "";
					left: 1px;
					height: 18px;
					width: 18px;
					border-radius: 50%;
					background-color: #fff;
					transition: all 0.1s ease;
				}
				> i {
					display: none;
				}
			}

			> input {
				display: none;
				&:checked + span {
					color: var(--color-1);
					&::after {
						left: 21px;
					}
					&::before {
						background-color: var(--color-1);
					}
				}
			}
		}
	}
	.inter-bar {
		display: flex;
		flex-wrap: wrap;
		margin: 0 -16px -16px 0;
		@media (max-width: 767px) {
			margin: 0;
			flex-direction: column;
			width: 100%;
		}
		&__add-org {
			margin: 0 16px 16px 0;
			@media (max-width: 767px) {
				margin: 0 0 16px 0;
			}
		}
		&__search {
			display: flex;
			flex-grow: 1;
			margin: 0 16px 16px 0;
			@media (max-width: 767px) {
				margin: 0;
			}
			align-items: center;
			position: relative;
			> input {
				display: flex;
				align-self: stretch;
				width: 100%;
				outline: none;
				padding: 0 52px 0 22px;
				border-radius: 50px;
				border: 1px solid #c5cde0;
				color: var(--text-black);
				@media (max-width: 767px) {
					flex-direction: column;
					min-height: 40px;
				}
			}
			> i {
				position: absolute;
				right: 20px;
				color: #c5cde0;
				font-weight: 100;
				font-size: 18px;
			}
		}
	}

	.clinics {
		display: flex;
		flex-direction: column;
		max-width: var(--module-width-1);

		&__header {
			padding: 24px 0;
			border-bottom: 1px solid var(--border-gray-2);
			color: var(--text-black-1);
		}

		&__add-org {
			display: flex;
			align-self: center;
			padding: 12px 16px;
			border-radius: 8px;
			background: var(--color-1);
			color: var(--text-main-1);
		}

		&__list {
			display: flex;
			flex-direction: column;
		}
	}
	.item {
		display: flex;
		padding: 24px 0;
		position: relative;

		@media (max-width: 991px) {
			flex-direction: column;
		}

		&__name {
			word-break: break-all;
		}

		&__clickable {
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			z-index: 1;
			cursor: pointer;
		}

		&__wrap {
			display: flex;
			flex-grow: 1;
		}

		&__info {
			display: flex;
			word-break: break-all;
		}

		&__content {
			display: flex;
			flex-grow: 1;
			flex-direction: column;
			justify-content: space-evenly;
			color: var(--text-black-1);
		}

		&__moderation {
			font-size: 13px;
			color: var(--text-gray-1);
		}

		&__verified {
			position: absolute;
			height: 20px;
			width: 20px;
			top: 78%;
			left: 78%;
			cursor: help;
			display: flex;
			align-items: center;
			justify-content: center;

			> i {
				position: absolute;
				pointer-events: none;
			}
			.star {
				color: var(--color-1);
				font-size: 19px;
			}
			.checkmark {
				color: var(--text-main-1);
				font-size: 10px;
			}
		}

		&__logo {
			height: 65px;
			width: 65px;
			display: flex;
			flex-shrink: 0;
			margin-right: 16px;
			position: relative;
			z-index: 2;
			&-blank {
				padding: 15px;
			}
			> img {
				height: 100%;
				width: 100%;
				border: 1px solid var(--border-gray-3);
				border-radius: 8px;
				object-fit: cover;
			}
		}

		&__promote {
			display: flex;
			align-self: center;
			padding: 12px 16px;
			border-radius: 8px;
			margin-left: 16px;
			position: inherit;
			z-index: 2;
			background: var(--color-1);
			color: var(--text-main-1);

			@media (max-width: 991px) {
				width: 100%;
				margin: 16px 0 0 0;
				text-align: center;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}
	}
</style>
